import React from 'react';
import { DiaryTable } from '@/components/DiaryTable';
import { DiaryChangesCard } from '@/components/DiaryTable/DiaryChangesCard';
import type { DiaryEntry } from '@/types/diary';
import { countChangedLessons } from '@/utils/diary';

interface Props {
  entry: DiaryEntry;
}

export const DiaryDay: React.FC<Props> = ({ entry }) => {
  const changedLessonCount = countChangedLessons(entry.lessons);

  return (
    <>
      {changedLessonCount > 0 && (
        <DiaryChangesCard changedLessonCount={changedLessonCount} />
      )}
      <DiaryTable entry={entry} />
    </>
  );
};
